module.exports = __webpack_public_path__ + "static/media/dekmantel.66c120d1.jpg";